// Behaviors
require("./behaviors/01.image-bg");
require("./behaviors/02.anchor-link");
require("./behaviors/02.back-to-top");
require("./behaviors/03.fancybox");
require("./behaviors/04.slide");
require("./behaviors/05.header-fixed");
require("./behaviors/06.box-carousel-values");
require("./behaviors/06.box-gallery-carousel");
require("./behaviors/06.box-gallery-plants");
require("./behaviors/06.box-gallery02");
require("./behaviors/07.menu");
require("./behaviors/20.masks");
